import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

interface ReverseGeocodeParams {
    latitude: number
    longitude: number
}

export interface ReverseGeocodeResult {
    street_address: string | null
    city: string
    state: string
    postal_code: string
    formatted_address: string
}

interface ForwardGeocodeParams {
    address: string
}

export interface ForwardGeocodeResult {
    street_address: string | null
    city: string
    state: string
    postal_code: string
    formatted_address: string
    latitude: number
    longitude: number
}

export const geocodingApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        reverseGeocode: builder.mutation<ReverseGeocodeResult, ReverseGeocodeParams>({
            query: ({ latitude, longitude }) => ({
                url: apiEndpoints.geocoding.reverse,
                method: 'POST',
                body: { latitude, longitude },
            }),
        }),
        forwardGeocode: builder.mutation<ForwardGeocodeResult, ForwardGeocodeParams>({
            query: ({ address }) => ({
                url: apiEndpoints.geocoding.forward,
                method: 'POST',
                body: { address },
            }),
        }),
    }),
})

export const { useReverseGeocodeMutation, useForwardGeocodeMutation } = geocodingApi
